export default __webpack_public_path__ + "static/media/data.4fe1a30e.png";